exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}*{transform-style:flat;-webkit-user-drag:none;outline:0;-ms-box-sizing:border-box;-o-box-sizing:border-box;box-sizing:border-box}body,html{height:100%}div{position:relative}body,html{margin:0;padding:0}.flex{display:flex;flex-wrap:wrap}.item{width:10vw;height:10vw;padding:1em}.circle{border-radius:100%;background:#d64955}.circle,.square{width:100%;height:100%}.square{background:#bcbfe3;transform:rotate(45deg) scale(.7)}.scroll-x{position:fixed;top:0;width:1000vw;height:100vh;mix-blend-mode:color-dodge;overflow:auto;pointer-events:none;will-change:transform}@media (max-width:768px){.scroll-x{width:1000vh}.item{width:20vw;height:20vw;padding:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/App.css
// module id = 124
// module chunks = 0